import React, { useCallback, useEffect, useState } from "react";
import Table from "../../components/table/Table";
import { useSelector } from "react-redux";
import FixedAgent from "../../utils/api/FixedAgent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./History.module.css";
import TableLoader from "../../components/ui/TableLoader";
import Pagination from "../../components/list/Pagination";
import { fetchWithSearchFallback } from "../../utils/searchFallback";
import useDebouncedValue from "../../hooks/useDebouncedValue";

function DebitHistory() {
  const [allTransactions, setAllTransactions] = useState(null);
  const [filteredTransactions, setFilteredTransactions] =
    useState(allTransactions);
  const [searchInput, setSearchInput] = useState("");
  const debouncedSearch = useDebouncedValue(searchInput);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageIsLoading, setPageIsLoading] = useState(false);
  const [serverSearchAvailable, setServerSearchAvailable] = useState(null);
  const [usingServerSearch, setUsingServerSearch] = useState(false);

  const token = useSelector((state) => state.userData.loginData.token);

  const fetchCustomers = useCallback(async () => {
    try {
      setPageIsLoading(true);
      const result = await fetchWithSearchFallback({
        search: debouncedSearch,
        serverSearchAvailable,
        fetchPage: ({ search }) => FixedAgent.getManualDebitHistory({ token, page: pageNumber, perPage: 25, search }),
      });
      setServerSearchAvailable(result.serverSearchAvailable);
      setUsingServerSearch(result.usedServerSearch);
      setAllTransactions(result.response.data.data);
      setPageIsLoading(false);
    } catch (error) {
      setPageIsLoading(false);
      toast.error(error?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Failed to fetch customers", error);
    }
  }, [token, pageNumber, debouncedSearch, serverSearchAvailable]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  useEffect(() => {
    const transactions = allTransactions?.data || allTransactions;
    if (searchInput === "" || usingServerSearch) {
      setFilteredTransactions(transactions);
    } else {
      const filtered = transactions?.filter((customer) =>
        customer.plate_details?.fullname
          ?.toLowerCase()
          ?.includes(searchInput?.toLowerCase())
      );
      setFilteredTransactions(filtered);
    }
  }, [searchInput, allTransactions, usingServerSearch]);
  return (
    <div>
      <ToastContainer />

      {!pageIsLoading ? (
        <div>
          {" "}
          <div className={styles.filter_wrapper}>
            <input
              type="text"
              value={searchInput}
              onChange={(e) => { setSearchInput(e.target.value); setUsingServerSearch(false); setPageNumber(1); }}
              placeholder={serverSearchAvailable === false ? "Filter this page by buyer name" : "Search by buyer name"}
              className={styles.filter_input}
            />
            <button className={styles.export_button}>Export</button>
          </div>
          <Table tableData={filteredTransactions} />
          <Pagination
            pagination={{ page: allTransactions?.current_page || pageNumber, lastPage: allTransactions?.last_page || 1, total: allTransactions?.total || 0, hasNextPage: pageNumber < (allTransactions?.last_page || 1), hasPreviousPage: pageNumber > 1 }}
            onPageChange={setPageNumber}
            isLoading={pageIsLoading}
          />
        </div>
      ) : (
        <TableLoader />
      )}
    </div>
  );
}

export default DebitHistory;
